export const emojiMap = {
  ":amaz:": "https://cdn.discordapp.com/emojis/1395929641285324860.webp?size=96",
  ":zama1:": "https://cdn.discordapp.com/emojis/1395929637594599465.webp?size=96&animated=true",
  ":fhe:": "https://cdn.discordapp.com/emojis/1298251579492798485.webp?size=96",
  ":justz:": "https://cdn.discordapp.com/emojis/1298251347296124998.webp?size=96",
  ":httpz:": "https://cdn.discordapp.com/emojis/1298252633773183027.webp?size=96",
  ":bro:": "https://cdn.discordapp.com/emojis/1298252212027392041.webp?size=96",
  ":zama:": "https://cdn.discordapp.com/emojis/1298251385493524510.webp?size=96",
  ":zama2:": "https://cdn.discordapp.com/emojis/1314164317427597322.webp?size=96",
};